import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { PostHogService } from './posthog.service';

/**
 * `capture_pageview: 'history_change'` dedupes on pathname, which double-counts every redirect and
 * lowercase rewrite and misses query-only navigations entirely. `NavigationEnd` is the router's own
 * definition of a completed navigation, and it is the one angulartics2 already counts into GA.
 */
@Injectable({ providedIn: 'root' })
export class PostHogRouteTrackingService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly postHog = inject(PostHogService);
  private readonly router = inject(Router);

  public init(): void {
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((event) => event instanceof NavigationEnd),
      )
      .subscribe(() => this.postHog.capture('$pageview'));
  }
}
